// TypeScript types for Sales Funnel feature

export interface FunnelStage {
  stage: 'prospect' | 'prepare_qualify' | 'present' | 'follow_up';
  count: number;
  avg_value: number;
  total_value: number;
  weighted_value: number;
  stage_probability: number;
  at_risk_count: number;
  avg_days_in_stage: number;
  aging_deals_count: number;
}

export interface ClosedStage {
  stage: 'closed_won' | 'closed_lost';
  count: number;
  total_value: number;
  stage_probability: number;
}

export interface FunnelSummary {
  weighted_pipeline: number;
  pipeline_coverage: number;
  total_at_risk: number;
  avg_deal_size: number;
  total_opportunities: number;
  avg_sales_cycle_days: number;
}

export interface ConversionRates {
  prospect_to_prepare_qualify: number;
  prepare_qualify_to_present: number;
  present_to_follow_up: number;
}

export interface FunnelData {
  stages: FunnelStage[];
  closed: ClosedStage[];
  summary: FunnelSummary;
  conversion_rates: ConversionRates;
}

export interface FunnelAPIResponse {
  success: boolean;
  data: FunnelData;
}

// Stage display configuration - Teal gradient progression matching Figma mockup
export const STAGE_CONFIG: Record<string, { label: string; color: string }> = {
  prospect: {
    label: 'Prospect (Sales Qualified)',
    color: '#E8F4F6', // Lightest teal
  },
  prepare_qualify: {
    label: 'Prepare/Qualify',
    color: '#C4E5E9', // Light teal
  },
  present: {
    label: 'Present',
    color: '#A0D3DB', // Medium teal
  },
  follow_up: {
    label: 'Follow-Up',
    color: '#7CC4CF', // Darker teal
  },
  closed_won: {
    label: 'Closed Won',
    color: '#22C55E', // Green (terminal stage)
  },
  closed_lost: {
    label: 'Closed Lost',
    color: '#6B7280', // Gray (terminal stage)
  },
};
